<template>
  <div class="bg-white rounded box-shadow p-3">
    <b-modal id="add-payment" size="lg" title="Add Payment" hide-footer>
      <div class="modal-content bg-white rounded box-shadow">
        <div class="form-row">
          <div class="col-md-12 col-sm-12 col-lg-12">
            <label for="payment_date" class="col-form-label col-form-label-sm">Payment Date</label>
            <datepicker
                    v-model="voucher.payment_date"
                    v-validate="'required'"
                    id="payment_date"
                    name="payment_date"
                    :format="customPaymentDate" :disabled-dates="disabledDates"
                    placeholder="Payment Date">
            </datepicker>
            <div class="text-danger" v-if="errors.has('payment_date')" style="margin-top: 0.25rem; font-size: 0.75rem;">
              Payment date required
            </div>

          </div>
        </div>
        <div class="form-row mt-3 mb-3">
          <div class="float-right">
            <b-button variant="success"
              class="form-control-sm mr-2" @click.prevent="save"
              >Add</b-button
            >
            <b-button
              size="sm"
              variant="danger"
              class="form-control-sm"
              @click="$bvModal.hide('add-payment')"
              >Cancel</b-button
            >
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import http from "@state/http";
import moment from "moment";
import Datepicker from "vuejs-datepicker";

export default {
  name: "AddRole",
  props: ["voucher"],
  components: { Datepicker },
  data() {
    return {
      validation_errors: {},
      payment_date: "",
      checkedData: true,
      disabledDates: {
        from: new Date(Date.now())
      },
    };
  },

  methods: {
    save() {
      var voucherId = this.voucher.id;
      this.$validator.validate().then(valid => {
        if (valid) {
          http
            .post("api/trainee/voucher/payment/add/"+ voucherId, this.voucher)
            .then(response => {
              if (!response.data.error) {
                this.$bvToast.toast(response.data.message, {
                  title: "Success",
                  autoHideDelay: 5000,
                  variant: "success"
                });
               this.$bvModal.hide("add-payment");
                this.$emit("search");
              }
            })
            .catch(error => {
              this.validation_errors = error.response.data.errors;
              this.$bvModal.hide("add-payment");
            });
        }
      });
    },
    customPaymentDate(date) {
      this.voucher.payment_date = moment(date).format("YYYY-MM-DD");
      return moment(date).format("YYYY-MM-DD");
    },
  },
  mounted() {}
};
</script>
